import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import dpgMedia from '../../assets/media/logo-dpgmedia.svg';
import expedia from '../../assets/media/logo-expedia.svg';
import mailchimp from '../../assets/media/logo-mailchimp.svg';
import siemens from '../../assets/media/logo-siemens.svg';
import target from '../../assets/media/logo-target.svg';
import twilio from '../../assets/media/logo-twilio.svg';
import underArmour from '../../assets/media/logo-underarmour.svg';
import walmart from '../../assets/media/logo-walmart.svg';
import workiva from '../../assets/media/logo-workiva.svg';

const logos = [
  { width: 140, src: dpgMedia, name: 'DPG Media', offset: -11 },
  { width: 150, src: expedia, name: 'Expedia' },
  { width: 175, src: mailchimp, name: 'MailChimp' },
  { width: 140, src: siemens, name: 'Siemens' },
  { width: 70, src: target, name: 'Target' },
  { width: 125, src: twilio, name: 'Twilio' },
  { width: 250, src: underArmour, name: 'Under Armour' },
  { width: 160, src: walmart, name: 'Walmart' },
  { width: 150, src: workiva, name: 'Workiva', offset: -5 },
];

// A little trickery do-dad to get the exact width of the current logo-set so our modern infinite marquee 😑 works as expected
// @NOTE Using $global-whitespace-large = 32px for offset between each one
const maxWidth =
  logos.reduce((acc, cur) => {
    return acc + cur.width;
  }, 0) +
  logos.length * 32 * 2;

const CustomerLogos = ({ className, contrast }) => {
  const classes = cx(
    'section customerLogos-section',
    {
      'u-contrast': contrast,
    },
    className
  );

  const Logos = () => (
    <div className="customerLogos-blob" style={{ width: `${maxWidth}px` }}>
      {logos.map(logo => (
        <img
          key={logo.name}
          style={{
            width: `${logo.width}px`,
            position: 'relative',
            top: `${logo.offset}px` || 0,
          }}
          src={logo.src}
          alt={logo.name}
        />
      ))}
    </div>
  );

  return (
    <section className={classes}>
      <div className="customerLogos" style={{ maxWidth: `${maxWidth}px` }}>
        {/* Duping this so we can use CSS animation to emulate infinite scroll without the need for an external library */}
        <Logos />
        <Logos />
      </div>
    </section>
  );
};

CustomerLogos.propTypes = {
  className: PropTypes.string,
  contrast: PropTypes.bool,
};

export default CustomerLogos;
